export default "__VITE_ASSET__Dzs59ZW6__"